import { graphql, useStaticQuery } from "gatsby";

// ToDo: Find a way not to hardcode language regex here

export default function useQueryArticlesCareersHubFeatured() {
  return useStaticQuery(
    graphql`
      {
        posts: allStoryblokEntry(
          filter: {
            field_component: { eq: "blogPost" }
            field_isCareersHubFeatured_boolean: { eq: true }
            full_slug: { regex: "/^en-gb//" }
          }
          sort: { fields: field_date_string, order: DESC }
          limit: 5
        ) {
          nodes {
            assets {
              id
              publicURL
              fields {
                aspectRatio
              }
              childImageSharp {
                gatsbyImageData(width: 600)
              }
            }
            id
            content
            full_slug
          }
        }
      }
    `
  );
}
